<template>
  <v-form class="py-4">
    <div class='mt-2'>
      <v-text-field
        v-model="item.title"
        outlined
        maxLength="25"
        :label="$t('shardList.detail.name_company')"
        class="lfs-text-field lfs-required lfs-mb-20"
        height="50"
        :counter='25'
      />
    </div>

    <div class='mt-2'>
      <v-textarea
        :value="item.description"
        color='#2c9cdb'
        class='lfs-textarea'
        item-color='#2c9cdb'
        :label="$t('shardList.detail.description')"

      />
    </div>
  </v-form>
</template>

<script>
export default {
  props: ['value'],
  data: () => ({
    rules: [v => v.length <= 400 || 'Максимальное количество символов - 400'],
  }),
  computed: {
    item: {
      get() {
        return this.value
      },
      set(newVal) {
        this.value = newVal
      }
    }
  }
}
</script>

<style>
 .lfs-pd-edit-textarea .v-text-field__details {
   left: 20px;
   width: calc(100% - 35px)
 }
</style>
